import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var ZoomIn = createReactComponent("ZoomIn", ["svg", defaultAttributes, [["circle", {
  cx: "11",
  cy: "11",
  r: "8",
  key: "18pnwe"
}], ["line", {
  x1: "21",
  y1: "21",
  x2: "16.65",
  y2: "16.65",
  key: "u0ckfk"
}], ["line", {
  x1: "11",
  y1: "8",
  x2: "11",
  y2: "14",
  key: "1n5115"
}], ["line", {
  x1: "8",
  y1: "11",
  x2: "14",
  y2: "11",
  key: "1u5rbm"
}]]]);
export default ZoomIn;